function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M117.018,19.072c-1.411-6.289-6.417-10.91-12.449-11.616   C90.32,5.852,75.88,5.852,61.504,5.852s-28.816,0-43.064,1.604C12.407,8.162,7.466,12.783,6.054,19.072   C4,27.993,4,37.748,4,46.926s0,18.933,1.99,27.854c1.412,6.289,6.417,10.91,12.45,11.616C32.688,88,47.128,88,61.504,88   s28.816,0,43.064-1.604c6.032-0.706,11.038-5.327,12.386-11.616c2.054-8.921,2.054-18.676,2.054-27.854   S119.008,27.993,117.018,19.072z M84.223,50.392L51.364,70.929c-0.642,0.449-1.412,0.642-2.182,0.642   c-0.706,0-1.348-0.192-1.99-0.514c-1.283-0.706-2.118-2.117-2.118-3.594V26.389c0-1.477,0.834-2.888,2.118-3.594   c1.284-0.706,2.888-0.706,4.172,0.128L84.223,43.46c1.22,0.706,1.926,2.054,1.926,3.466S85.442,49.686,84.223,50.392z"
});

var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-social-youtube",
    viewBox: "0 0 125 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube.67b48877.svg";
export { ForwardRef as ReactComponent };